import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import React, { useContext, useEffect, useState } from "react";
import esiSourceWrapper from "@/constants/esiSourceWrapper";
import { getSolutionContactDetailsByTag } from "@/utils/data/getContactDetails";
import ContactMethods from "@/components/contact-details-box/contact-methods/ContactMethods";
import { ContactDetailsContext } from "../../../../context/contact-details-context";
import ContactDetailsBox from "@/components/contact-details-box/ContactDetailsBox";
import SlideIn from "@/components/slide-in/SlideIn";
import { useDecisionTreeLocation } from "@/hooks";
import styles from "./screens.module.scss";

function SolutionOther() {
    const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  const [contactConfig, setContactConfig] = useState(null);
  const location = useDecisionTreeLocation();

  useEffect(() => {
    getSolutionContactDetailsByTag(
      "returnsAndRefunds-returningOrExchanging"
    ).then(config => setContactConfig(config));
  }, []);

  const contactFields = [{ name: "phone", key: "number" }];
  if(liveChatProminenceExperiment) contactFields.push({ name: "chat", key: "channel" });
  return (
    <div className={styles.landingPageSolutionContainer}>
      <div className={styles.solutionESIContainer}>
        <ESIInclude
          src={esiSourceWrapper(
            "/content-renderer/content/returnsandrefunds/other"
          )}
          id="content"
        />
      </div>
      <div className={styles.solutionViewContactDetailsContainer}>
        {!contactConfig && <LoadingSpinner />}
        {contactConfig ? liveChatProminenceExperiment ? (
          <SlideIn>
            <ContactDetailsBox
              title="We’re here to help"
              fields={contactFields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
              solutionId={contactConfig.solution}
              location={location}
              otherContactDetails={contactConfig}
              viewContactDetails
              showContactDetailsByDefault
            />
            </SlideIn>) : (
          <SlideIn>
            <ContactMethods
              fields={contactFields.map(obj =>
                contactConfig[obj.name]
                  ? {
                      name: obj.name,
                      content: contactConfig[obj.name][obj.key]
                    }
                  : null
              )}
              solutionId={contactConfig.solution}
              location={location}
              contactDetails={contactConfig}                
            />
          </SlideIn>
        ) : null}
      </div>      
    </div>
  );
}

export default SolutionOther;
